import { useEffect, useState } from 'react';

import { useStickyTopHeaderClassName } from '@swf/cms';
import { useRefs } from '@swf/core/providers/RefsProvider';

const useIsHeaderInView = () => {
  const [isHeaderInView, setIsHeaderInView] = useState<boolean>(true);
  const { isStickyHeader: isStickyTopHeader } = useStickyTopHeaderClassName('header');
  const { refs } = useRefs();
  const header = refs.get('header');
  const topHeader = refs.get('topHeader');

  useEffect(() => {
    if (!header?.current) {
      setIsHeaderInView(false);
      return;
    }

    const observer = new IntersectionObserver(([e]) => setIsHeaderInView(e.isIntersecting), {
      rootMargin: `-${
        !isStickyTopHeader ? 0 : topHeader?.current?.getBoundingClientRect().height ?? 0
      }px 0px 0px 0px`
    });

    observer.observe(header.current);

    return () => observer.disconnect();
  }, [header, topHeader, isStickyTopHeader]);

  return isHeaderInView;
};

export default useIsHeaderInView;
